export default "__VITE_ASSET__uY7uiOEL__";